import { Id } from './aliases'
import { uint8ToUrlBase64 } from './utils'

export const routes = {
  noAuthority: '/no-authority',
  reauth: '/reauth',
  orgReauth: (orgPublicId: Id) =>
    `/orgs/${uint8ToUrlBase64(orgPublicId)}/reauth`,
}
